import * as React from "react";
import { connect } from "react-redux";
import Modal from "../Modal";

class LoginModal extends React.Component {
    constructor(props) {
        super(props);
        
        this.loadingRef = null;
        this.setLoadingRef = element => {
            this.loadingRef = element;
        };
    }
    loadingRef = null;
    setLoadingRef = null;
    startInitUrs() {
        var ursConfig = {
            single : 1,
        	newCDN: 1,
        	version: 3,
            includeBox : 'urs-login',
            isHttps : 1,
            page : 'login',
            placeholder : {account:'邮箱帐号',pwd:'输入密码'},
            autoFocus: 1,
            swidth: 320,
            product: 'vip_activity',
            promark: 'vkdNpFl',
            productKey: '7c4d652320684041b7d88610eb9dd814',
            host : 'vip.163.com',
            cookieDomain: 'vip.163.com',
            domains: 'vip.126.com,vip.163.com,188.com,126.com,yeah.net',
            chromeSupport: 1,
            customStyles: {
                imagePanel: {
                    align: 'top',
                    borderRadius: '5px'
                },
                controlBar: {
                    height: '40px'
                },
                gap: '2px'
            },
            capPadding: 10,
            capBarHeight: 40,
            bgpTime: 10000,
            bgpTime2: 10000,
            needPrepare: 1,
            // domainSuffixs : '@vip.163.com,@vip.126.com,@188.com',
            logincb : (_username) => {
                window.location.reload();
                // this.__onLoginOk(_username);
            },
            initReady: () => {
                if (this.loadingRef) {
                    (this.loadingRef).style.display = 'none';
                }
            },
        };
        window.URS && window.URS.setPkidAndPd({
            pkid: 'BAyeoVg',
            pd: 'vip_pay',
            mode: 1
        });
        // setTimeout(function () {
        new window.URS(ursConfig);
        // }, 0);
    }
    componentDidMount() {
        this.startInitUrs();
    }
    __onLoginOk(_username) {
        const { onLoginOk } = this.props;
        onLoginOk && onLoginOk(_username);
    }
    __onClose() {
        const {onClose} = this.props;
        onClose && onClose();
    }
    render() {
        const {isOpen} = this.props;
        return (
            <Modal isOpen={isOpen} title="登录您的帐号" className="w-login-modal" onClose={this.__onClose.bind(this)}>
                <div className="loginbox J_iframebox">
                    <div id="urs-login" className="urslogin"></div>
                </div>
                <div ref={this.setLoadingRef} className="u-loading-wrapper">
                    <p><i></i><span>载入中...</span></p>
                </div>
            </Modal>
        );
    }
}

function mapStateToProps(state) {
    return {
    }
}

function mapDispatchToProps(dispatch) {
    return {}
}

export default connect(mapStateToProps, mapDispatchToProps)(LoginModal);
